export class CaptchaConfig {
  public static get url(): string {
    return 'https://challenges.cloudflare.com/turnstile/v0/api.js';
  }
}
